/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';
import { getXiaomiCareUrl } from './careUrl';

// 需在渲染时求值：模块级常量在单页应用里只求值一次，跨过切换时刻而未刷新页面会一直用旧链接
const getHtmlContent = () => {
    const url = getXiaomiCareUrl();
    return `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">To deliver the product(s) you order in our store to the address you designate, Xiaomi will collect <strong>your name, phone number and delivery address</strong> as you provide here and <strong>share them with our delivery service partner</strong> that will deliver the product(s) to you.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">The legal basis for this processing of your personal data is that <strong>it is necessary for performing a contract to which you are a party.</strong></span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">You may exercise your data protection rights (e.g., access, rectification and/or erasure) through our Privacy Support Platform (
                        <a href="https://privacy.mi.com/support/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/support/
                            </span>
                        </a>
                        ).
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">You may find further information about the processing of your personal data by referring to our Privacy Policy (
                        <a href="https://privacy.mi.com/all/languages/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/all/languages/
                            </span>
                        </a>
                        ).
                    </span>
                </p>
                <br />
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Please review and confirm the terms in the "Xiaomi Care Terms of Use"(<a href="${url}" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">${url}</span></a>) before purchase, and sign to acknowledge.</span>
                </p>
                <br />
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">By signing below, you acknowledge that you have read, understood, and agree to the above terms.</span>
                </p>
            </div>
        </body>
    </html>`;
};


function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(getHtmlContent())}
        </div>
    )
}

export default memo(ProtocolPage)
